import { createContext, useState, useEffect } from "react";
import { API_BASE_URL } from "../constants/apiConfig";

const LoginContext = createContext({});

export const LoginProvider = ({ children }: any) => {
  const [isloggedIn, setIsLoggedIn] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [modelData, setModelData] = useState({
    isOpen: false,
    title: "",
    message: "",
  });
  const [userRole, setUserRole] = useState("");
  const [userName, setUserName] = useState("");
  const [userId, setUserId] = useState(null);

  // Check login status on provider mount
  useEffect(() => {
    fetch(`${API_BASE_URL}/admin/isLoggedIn`, {
      credentials: "include",
    })
      .then((response) => response.json())
      .then((data: any) => {
        if (data.status > 0) {
          setIsLoggedIn(true);
          setUserRole(data.role); // Assuming the response includes the user's role
          setUserName(data.name); // Assuming the response includes the user's name
          setUserId(data.userId); // Assuming the response includes the user's ID
        }
      })
      .catch((error) => {
        console.error("Login check failed:", error);
      });
  }, []);

  return (
    <LoginContext.Provider
      value={{
        isloggedIn,
        setIsLoggedIn,
        isLoading,
        setIsLoading,
        modelData,
        setModelData,
        userRole,
        setUserRole,
        userName,
        setUserName,
        userId,
        setUserId,
      }}
    >
      {children}
    </LoginContext.Provider>
  );
};

export default LoginContext;
